import React from "react";
import { TextField, InputAdornment, Button, Tooltip } from "@mui/material";
import { Filter, Filter1, FilterAlt, Search } from "@mui/icons-material";
import "../Common/css/user.css";

interface TableToolbarProps {
  title: string;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  isButton?: boolean;
  buttonText: string;
  onButtonClick: () => void;
  buttonIcon?: React.ReactNode;
  isFiltered?: boolean;
  onFilterClick?: () => void;
}

const TableToolbar: React.FC<TableToolbarProps> = ({
  title,
  searchTerm,
  setSearchTerm,
  isButton = true,
  buttonText,
  onButtonClick,
  buttonIcon,
  isFiltered = false,
  onFilterClick = () => { },
}) => {
  return (
    <div className="table-title-outer">
      <div className="table-title">{title}</div>
      <div className="table-toolbar-actions" style={{ display: "flex", alignItems: "center" }}>
        {isFiltered && (
          <div style={{ cursor: "pointer", marginRight: "10px" }} onClick={onFilterClick}>
            <Tooltip title="Filter Ban Students">
              <FilterAlt style={{ color: "#ffffff" }} />
            </Tooltip>
          </div>
        )}
        <TextField
          className="search-input"
          variant="outlined"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          size="small"
          sx={{
            width: "250px",
            marginRight: "10px",
            backgroundColor: "#393939",
            input: {
              color: "#ffffff",
              height: "1em",
              "::placeholder": {
                color: "grey",
                opacity: 1,
              },
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#555",
              },
              "&:hover fieldset": {
                borderColor: "#aaa",
              },
              "&.Mui-focused fieldset": {
                borderColor: "gray",
              },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search style={{ color: "#ffffff" }} />
              </InputAdornment>
            ),
          }}
        />

        {isButton && (
          <Button
            className="primary-btn"
            variant="contained"
            size="small"
            onClick={onButtonClick}
            startIcon={buttonIcon}
          >
            {buttonText}
          </Button>
        )}

      </div>
    </div>
  );
};

export default TableToolbar;
